@if (result && question) {
  <div class="quiz-result-item">
    <span class="question-label">QUESTION {{ questionNumber }}/{{ totalQuestions }}</span>
    <p class="question-text" [innerHTML]="getQuestionHtml(question.questionText)"></p>
    <div class="answer-row">
      <span
        class="answer-icon"
        [class.correct]="isCorrect"
        [class.incorrect]="!isCorrect"
        [attr.aria-label]="isCorrect ? 'Correct Answer' : 'Incorrect Answer'"
        >
        <i class="material-icons" aria-hidden="true">
          {{ isCorrect ? 'check_circle' : 'cancel' }}
        </i>
      </span>
      <span class="answer-text">{{ result.answer }}</span>
    </div>
    @if (!isCorrect) {
      <div class="review-hint">
        <span class="review-hint-text">
          The correct answer can be found in <strong><em>"{{ courseTitle }}"</em></strong>
        </span>
        <button class="review-lesson-btn" (click)="onReviewLesson()">
          Review Lesson &rarr;
        </button>
      </div>
    }
  </div>
}
